import _ from "lodash";
import formatDate, { parseDate } from "./formatDate";
import { isSameDay, isValid } from "date-fns";
import { FilterValueTransformFn } from "../components/tables/types";

// Search table data (case insensitive) by fields which include the search term
export const searchTableData = (
  searchTerm: string,
  fields: string[],
  data: any[]
) => {
  return data.filter((item: any) => {
    // Iterate through fields and check if data item:
    // - has attribute
    // - has attribute which contains search term (case insenstive match, trailing whitespace removed)
    const results = fields.map(field => {
      const value = item[field];
      if (!value) return false;
      if (value instanceof Date) {
        return value
          .toLocaleDateString()
          .includes(searchTerm.trim().toLowerCase());
      }
      return value.toLowerCase().includes(searchTerm.trim().toLowerCase());
    });
    // If there is a positive result, return item as filtered result
    return results.includes(true);
  });
};

// Filter table data (case insensitive) by fields which include the filter parameters
export const filterTableData = (filterParameters: any, data: any[]) => {
  return data.filter((data: any) => {
    // Iterate through filter parameters
    const paramMatches = Object.keys(filterParameters).map((key: any) => {
      // If the filter parameter is a date field
      // ...return true if the values are of the same day
      const isDate = isValid(parseDate(filterParameters[key]));
      if (isDate) {
        return isSameDay(
          parseDate(data[key]),
          parseDate(filterParameters[key])
        );
      }

      // ...otherwise, parse property as lowercase string
      const value = String(data[key]).toLowerCase();
      // ...check if property contains lowercase filter param
      return value.includes(String(filterParameters[key]).toLowerCase());
    });
    // ...only return item if it meets all filter parameters
    return !paramMatches.includes(false);
  });
};

// Reduces data into unique label/value pairs for based on a given set of parameters
// used for filter select and typeahead input options
export const setFilterOptions = (
  data: any[],
  fields: {
    value: string;
    date?: boolean;
    transformFn?: FilterValueTransformFn;
  }[],
  initialValue: any
) => {
  return data.reduce(
    (all: any, item) => {
      const options: any = {};
      //   Iterate through fields
      fields.map(field => {
        //   ...if date field, format value into label
        const label = field.date
          ? formatDate.condensed(item[field.value])
          : field.transformFn
          ? field.transformFn(item[field.value])
          : item[field.value];
        //   ...return option with value/label pair
        return (options[field.value] = _.uniqBy(
          [...all[field.value], { label, value: item[field.value] }],
          //   Note: these options are unique by label (to prevent date duplicates)
          "label"
        ));
      });
      return {
        ...all,
        ...options
      };
    },
    { ...initialValue }
  );
};
